import React, {useState, useCallback} from 'react';
import {CheckboxField} from 'forms/src';
import t from 'rcm-i18n';
import {ReadAndAcceptStepConfig} from '../../types';
interface Props {
    readAndAcceptStep: ReadAndAcceptStepConfig;
    onContinueToNextStep: () => void;
}

const ReadAndAccept = (props: Props) => {
    const [isBoxChecked, setBoxChecked] = useState(false);
    const [
        userTriedToContinueWithoutCheckingBox,
         setUserTriedToContinueWithoutCheckingBox,
    ] = useState(false);

    const handleContinueButtonClick = useCallback(
        () => {
            if (isBoxChecked) {
                props.onContinueToNextStep();
            } else {
                setUserTriedToContinueWithoutCheckingBox(true);
            }
        },
        [isBoxChecked]
    );

    const handleCheckBoxValueChange = useCallback(
        (value: boolean) => {
            setBoxChecked(value);
        },
        []
    );

    return <div>
        <div className="read-and-accept-body" dangerouslySetInnerHTML={{__html: props.readAndAcceptStep.termsText}}/>
        {userTriedToContinueWithoutCheckingBox &&
            <>
                <br/>
                <div className="alert alert-warning" role="alert">
                    {t('You must check the box before continuing.')}
                </div>
            </>
        }
        <CheckboxField
            label={props.readAndAcceptStep.iAcceptText}
            value={isBoxChecked}
            onValueChange={handleCheckBoxValueChange}/>
        <button className="btn btn-primary" onClick={handleContinueButtonClick}>
            {t('Continue')}
        </button>
    </div>;
};

export default ReadAndAccept;
